import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import WorkflowDetailPage from '@features/admin/workflows/WorkflowDetailPage.tsx';
import { useAdminWorkflowStore } from '@features/admin/workflows/useAdminWorkflowStore.ts';

// Vybrany uzel v URL, at jde odkaz na konkretni krok poslat dal
const searchSchema = z.object({
  node: z.string().optional(),
});

export const Route = createFileRoute('/admin/workflows/$name')({
  validateSearch: search => searchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ({ params, cause }) => {
    // Kliknuti na uzel meni jen ?node= - detail kvuli tomu znovu nenacitat
    if (cause === 'stay') return;
    useAdminWorkflowStore.getState().loadWorkflowDetail(params.name);
  },
});

function RouteComponent() {
  const { name } = Route.useParams();
  const { node } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <WorkflowDetailPage
      name={name}
      selectedNodeId={node}
      onSelectNode={nodeId => navigate({ search: { node: nodeId }, replace: true, resetScroll: false })}
    />
  );
}
